import { Component } from '@angular/core';

@Component({
  selector: 'app-welcome-extras-bar',
  templateUrl: './welcome-extras-bar.component.html',
  styleUrls: ['./welcome-extras-bar.component.css']
})
export class WelcomeExtrasBarComponent { }



// WEBPACK FOOTER //
// ./src/app/page_components/welcome/welcome-extras-bar/welcome-extras-bar.component.ts